<div class="recent-message-item" message-node-id="message.nodeId" data-mfp-src="#main-popup" (click)="openPopup($event)">
  <div class="message-date">
    {{ message.date | date }}
  </div>

  <div class="message-content">
    <h4 class="message-title">{{ message.title }}</h4>

    <div class="message-text">{{ message.description }}</div>
  </div>
</div>